import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import LiftingInspectionForm from './components/LiftingInspectionForm';

const EditLiftingInspectionPage: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    return (
        <div className="animate-in fade-in duration-500">
            <LiftingInspectionForm 
                id={id ? parseInt(id) : undefined}
                onBack={() => navigate('/assets?tab=lifting')}
                onSaveSuccess={() => navigate('/assets?tab=lifting')}
            />
        </div>
    );
};

export default EditLiftingInspectionPage;
